import { CHARACTER_NAME_REGEX } from "@vinyl/shared";
import type { Store } from "../state.js";
import type { GameClient } from "../net/client.js";
import { el } from "./dom.js";

export function renderCharacterCreate(store: Store, client: GameClient): HTMLElement {
  const screen = store.get().screen;
  if (screen.kind !== "char_create") throw new Error("wrong screen");

  const card = el("div", { class: "card" });
  const logo = el("h1", { class: "logo" }, "Choose your name");
  const tagline = el(
    "p",
    { class: "tagline" },
    "3–16 letters or numbers. This is how others will know you.",
  );

  const form = el("form", { class: "form" });
  const input = el("input", {
    type: "text",
    class: "input",
    autocomplete: "off",
    autofocus: true,
    minlength: 3,
    maxlength: 16,
    pattern: "[A-Za-z0-9]{3,16}",
    placeholder: "Aldric",
    required: true,
  });

  const errorBox = el("div", { class: "error" }, screen.error ?? "");
  if (!screen.error) errorBox.style.display = "none";

  const button = el(
    "button",
    { type: "submit", class: "btn", disabled: screen.submitting },
    screen.submitting ? "Creating…" : "Step into Eldoria",
  );

  form.append(input, errorBox, button);
  form.addEventListener("submit", (ev) => {
    ev.preventDefault();
    const name = input.value.trim();
    if (!CHARACTER_NAME_REGEX.test(name)) {
      store.setScreen({ kind: "char_create", submitting: false, error: "Name must be 3–16 letters or numbers." });
      return;
    }
    store.setScreen({ kind: "char_create", submitting: true });
    client.send({ t: "createCharacter", d: { name } });
  });

  card.append(logo, tagline, form);
  const stage = el("div", { class: "stage" });
  stage.append(card);
  return stage;
}
